import { render, staticRenderFns } from "./coupon.vue?vue&type=template&id=5f35e283&scoped=true"
import script from "./coupon.vue?vue&type=script&lang=js"
export * from "./coupon.vue?vue&type=script&lang=js"
import style0 from "./coupon.vue?vue&type=style&index=0&id=5f35e283&prod&lang=scss&scoped=true"
import style1 from "./coupon.vue?vue&type=style&index=1&id=5f35e283&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f35e283",
  null
  
)

export default component.exports